import React from "react";
import { AccountLendingPoolPage } from ".";
import useGenericCall from "../../hooks/useGenericCall";
import { useOnchainLendingPool } from "../../hooks/useOnchain";

export interface AccountLendingPoolPageSelectorProps {
  pageSelected: AccountLendingPoolPage;
  setPageSelected: Function;
}

export default function AccountLendingPoolPageSelector({pageSelected, setPageSelected}: AccountLendingPoolPageSelectorProps) {
  const hasFarming = useGenericCall(useOnchainLendingPool(), onchainLendingPool => onchainLendingPool.hasFarming());
  return (
    <div className="account-lending-pool-page-selector">
      { pageSelected === AccountLendingPoolPage.LEVERAGE ? (
        <div className="selected">Borrowing</div>
      ) : (
        <div onClick={() => setPageSelected(AccountLendingPoolPage.LEVERAGE) }>Borrowing</div>
      ) }
      { pageSelected === AccountLendingPoolPage.EARN_INTEREST ? (
        <div className="selected">Lending</div>
      ) : (
         <div onClick={() => setPageSelected(AccountLendingPoolPage.EARN_INTEREST) }>Lending</div>
     ) }
     { (hasFarming) && (<>
      { pageSelected === AccountLendingPoolPage.FARMING ? (
        <div className="selected">Farming</div>
      ) : (
         <div onClick={() => setPageSelected(AccountLendingPoolPage.FARMING) }>Farming</div>
      ) }
     </>)}
    </div>
  );
}